import React, { useEffect } from 'react'
import { hot } from 'react-hot-loader'
import styled from 'styled-components'
import FormContainer from '../components/FormContainer/FormContainer'
import PartnersContainer from '../components/PartnersContainer/PartnersContainer'
import FormReminder from '../components/FormReminder/FormReminder'
import BannerLi from '../components/Banner/BannerLi'
import FooterLi from '../components/FooterLi'
import Avis from '../components/Avis/Avis'
import Tracking from '../../utils/helpers/Tracking'
import CookieBanner from '../components/BruceBannerLi'

const StyledBrandingContainer = styled.div``

function App() {
  useEffect(() => {
    Tracking.PushView({ pagename: 'moove-landing', site: 'LICOM' })
  }, [])

  return (
    <StyledBrandingContainer>
      <BannerLi />
      <FormContainer isLogicImmo />
      <PartnersContainer isLogicImmo />
      <Avis />
      <FormReminder isLogicImmo />
      <FooterLi />
      <CookieBanner />
    </StyledBrandingContainer>
  )
}

export default hot(module)(App)
